import { useNavigate } from 'react-router-dom'
import SmartGrid, { ColumnConfig } from '../../components/smartGrid/SmartGrid'
import { useAllTurnos } from '../../data/hooks/useTurnos.hook'
import { Turno, turnosConstants, TurnoStatus } from '../../data/types/turnos.type'
import { TurnoEstado } from './TurnoEstado.component'
import { useAuth } from '../../auth/AuthContext'
import { Role } from '../../data/types/medico.types'
import { Spinner } from '../../components/spinner/Spinner.component'

export const TurnosBrowse = () => {
	const { data: turnos, isPending, isError, error } = useAllTurnos()
	const navigate = useNavigate()
	const { role } = useAuth()

	const columns: ColumnConfig[] = role === Role.ADMIN ? [
		{
			key: 'fecha',
			header: 'Fecha',
			dataType: 'date',
			horizontalAlign: 'left',
			filterable: true,
			sortable: true,
			width: 10
		},
		{
			key: 'hora',
			header: 'Hora',
			dataType: 'text',
			horizontalAlign: 'left',
			filterable: true,
			sortable: true,
		},
		{
			key: 'pacienteNombre',
			header: 'Paciente',
			dataType: 'text',
			horizontalAlign: 'left',
			filterable: true,
			sortable: true,
		},
		{
			key: 'medicoNombre',
			header: 'Medico',
			dataType: 'text',
			horizontalAlign: 'left',
			filterable: true,
			sortable: true,
		},
		{
			key: 'statusTurno',
			header: 'Status',
			dataType: 'text',
			horizontalAlign: 'left',
			filterable: true,
			// filterDefault: TurnoStatus.PENDIENTE,
			filterOptions: [
				{ value: TurnoStatus.PENDIENTE, label: 'Pendiente' },
				{ value: TurnoStatus.CANCELADO, label: 'Cancelado' },
				{ value: TurnoStatus.IMPAGO, label: 'Impago' },
				{ value: TurnoStatus.COMPLETADO, label: 'Completado' },
			],
			sortable: true,
			formatter: (value: TurnoStatus) => {
				return TurnoEstado(value)
			}
		}
	]: [
		{
			key: 'fecha',
			header: 'Fecha',
			dataType: 'date',
			horizontalAlign: 'left',
			filterable: true,
			sortable: true,
			width: 10
		},
		{
			key: 'hora',
			header: 'Hora',
			dataType: 'text',
			horizontalAlign: 'left',
			filterable: true,
			sortable: true,
		},
		{
			key: 'pacienteNombre',
			header: 'Paciente',
			dataType: 'text',
			horizontalAlign: 'left',
			filterable: true,
			sortable: true,
		},
		{
			key: 'statusTurno',
			header: 'Status',
			dataType: 'text',
			horizontalAlign: 'left',
			filterable: true,

			filterOptions: [
				{ value: TurnoStatus.PENDIENTE, label: 'Pendiente' },
				{ value: TurnoStatus.CANCELADO, label: 'Cancelado' },
				{ value: TurnoStatus.IMPAGO, label: 'A Pagar' },
				{ value: TurnoStatus.COMPLETADO, label: 'Completado' },
			],
			sortable: true,
			formatter: (value: TurnoStatus) => {
				return TurnoEstado(value)
			}
		}
	]

	const rowActions = [
		{
			label: '',
			action: (selected: Turno[]) => navigate(`/med/turno/${selected[0].id}`),
			icon: '✏️'
		}
	]

	if (isPending) return <Spinner />

	return (
		<div style={{ margin: '0 150px' }}>
			{isError && <div style={{ color: 'red' }}>Error: {error?.message}</div>}
			{(!isPending && !isError) && <SmartGrid
				data={turnos || []}
				columns={columns}
				pageSize={10}
				rowActions={rowActions}
				defaultSort={{ key: 'fecha', direction: 'desc' }}
				toolbarComponents={[
				  {
					type: 'title',
					title: `Turnos`,
					count: true,
				  },
				]}
			/>}
		</div>
	)
}